import { useCallback, useState } from 'react'

/**
 * The Select' custom hook.
 */
const useSelect = ({
  initialValue = ''
} = {}) => {
  // const [error, setError] = useState('')
  const [value, setValue] = useState(initialValue)
  const handleChange = useCallback(
    event => {
      const updatedValue = event?.target?.value || ''
      setValue(updatedValue)
    }, []
  )

  return {
    error: '',
    value,
    setValue,
    onChange: handleChange
  }
}

export default useSelect
